// extracted by mini-css-extract-plugin
module.exports = {"heroMain":"styles_heroMain__o4z_y","buttonWrapper":"styles_buttonWrapper__NiA9U","spinner":"styles_spinner__9DUQO"};